import { useEffect } from 'react';
import { useToast } from '../components';
import { useActions, useAppData } from '../data';
import { pendingUnlocks } from '../lib/achievements';

/**
 * Headless tracker — runs the achievement evaluator after every state
 * change and, for any newly-met but not-yet-unlocked achievement, calls
 * `unlockAchievement(id)` and toasts a celebration. Mounted once near
 * the top of the tree; renders nothing.
 *
 * The evaluator is pure and cheap, so re-running on every data tick is
 * fine. We dispatch unlocks one at a time to give each its own toast.
 */
export function AchievementsTracker() {
  const data = useAppData();
  const actions = useActions();
  const toast = useToast();

  useEffect(() => {
    const ids = pendingUnlocks(data, new Date());
    if (ids.length === 0) return;
    for (const id of ids) {
      const a = data.achievements.find((x) => x.id === id);
      actions.unlockAchievement(id);
      if (a) {
        toast.show({
          message: `Achievement unlocked: ${a.title}`,
          kind: 'success',
          duration: 4000,
        });
      }
    }
    // We intentionally watch only the data identity — when state changes
    // we re-evaluate. actions/toast are stable refs.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return null;
}
